(function () {
  if (window.Shopify && Shopify.designMode) return;
  var body = document.body;

  function view() { return body.getAttribute('data-lugazi-view') || (new URLSearchParams(location.search).get('lugazi')) || 'home'; }
  function vw() { return document.documentElement.clientWidth; }
  function vh() { return innerHeight; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* the tilted hint is bigger than its straight box: keep the whole tilted drawing on screen (below the phone's
     status bar / notch) and still off the art - nudge it in, and if there is no room make it a bit smaller */
  var safeTop = 0;
  (function () { var d = document.createElement('div'); d.style.cssText = 'position:fixed;top:0;height:env(safe-area-inset-top,0px);visibility:hidden;pointer-events:none';
    document.body.appendChild(d); safeTop = d.offsetHeight || 0; d.remove(); })();

  var last = Date.now(), stops = 0;
  function scroller() {
    var w = document.querySelector('.page-wrapper');
    return w && /(auto|scroll)/.test(getComputedStyle(w).overflowY) && w.scrollHeight > w.clientHeight + 4 ? w : document.scrollingElement;
  }
  function nearEnd() {
    var s = scroller();
    return (s.scrollHeight - (s.scrollTop + s.clientHeight)) < Math.max(260, innerHeight * 0.35);
  }
  function scrollable() { var s = scroller(); return s.scrollHeight > s.clientHeight * 1.4; }
  document.addEventListener('scroll', function () { last = Date.now(); }, { passive: true, capture: true });
  ['touchstart', 'wheel', 'keydown'].forEach(function (t) { addEventListener(t, function () { last = Date.now(); }, { passive: true }); });

  /* ===== THE CAT TALKS =====
     One voice for the whole site: a hand-drawn speech bubble above the cat says what to do next, always in the same
     place. Entrance: "tap this icon". Home: "scroll down". BOOK: "scroll down" at the start, "keep on scrolling" in
     every part that holds still while you scroll, "scroll down" in the sideways chapter too (you scroll, it moves), and
     "join the list" when the logo lands at the end. */
  var coarse = matchMedia('(pointer: coarse)').matches;   /* phones: skip the heavy SVG filters, they cost frames */
  var SRC = document.querySelector('.lgz-src'), bub = document.querySelector('.lgz-bub');
  var bubIn = bub && bub.querySelector('.lgz-bub__in');
  var AR = '<svg class="lgz-ar %c" viewBox="0 0 24 32" aria-hidden="true"><path d="M12 3 C 11.2 10, 12.8 18, 12 28"/><path d="M4.5 20.5 C 7.5 23, 10 26, 12 29 C 14 26, 16.5 23, 19.5 20.5"/></svg>';
  function arrow(dir) { return AR.replace('%c', dir === 'up' ? 'lgz-ar--up' : dir === 'left' ? 'lgz-ar--left' : ''); }
  function img(k, w) { return '<img src="' + SRC.getAttribute('data-' + k) + '" alt="" style="width:' + w + 'px">'; }
  function txt(t) { return '<b class="lgz-txt">' + t + '</b>'; }
  /* Leandro's own speech bubbles and cat words (drawn on paper, cut out into one picture: lugazi-cat-bubbles.webp).
     A line is either one of his finished bubbles (CLICK ON THE BOOK!, SIGN UP..., Mjav..., $) or one of his empty
     bubbles with words inside: his own drawn words, his hint drawings, or text in his handwriting font. */
  var SPR = {"S":1.25,"W":560,"H":894,"items":{"bubA":{"x":300,"y":0,"w":250,"h":248,"tip":[0.011,0.996],"inner":[0.16,0.1,0.86,0.44]},"bubB":{"x":0,"y":545,"w":162,"h":161,"tip":[0.021,0.994],"inner":[0.22,0.11,0.91,0.6]},"square":{"x":0,"y":285,"w":200,"h":248,"tip":[0.5,0.996],"inner":[0.1,0.08,0.9,0.66]},"wide":{"x":212,"y":285,"w":288,"h":163,"tip":[0.97,0.994],"inner":[0.08,0.11,0.8,0.57]},"click":{"x":174,"y":545,"w":256,"h":136,"tip":[0.354,0.993]},"signup":{"x":0,"y":0,"w":288,"h":273,"tip":[0.834,0.996]},"mjav":{"x":0,"y":718,"w":150,"h":136,"tip":[0.588,0.993]},"dollar":{"x":162,"y":718,"w":112,"h":124,"tip":[0.664,0.992]},"hello":{"x":152,"y":866,"w":90,"h":25,"tip":[0.371,0.96]},"scroll":{"x":286,"y":718,"w":115,"h":55,"tip":[0.98,0.982]},"prrr":{"x":413,"y":718,"w":92,"h":45,"tip":[0.966,0.978]},"prrr2":{"x":418,"y":866,"w":105,"h":20,"tip":[0.029,0.95]},"mjaw":{"x":0,"y":866,"w":140,"h":28,"tip":[0.275,0.964]},"miaow":{"x":254,"y":866,"w":152,"h":24,"tip":[0.009,0.958]}}};
  function spr(k) { var it = SPR.items[k], f = 1 / SPR.S;
    return '<i class="lgz-spr" style="background-image:url(' + SRC.getAttribute('data-bubbles') + ');width:' + (it.w * f).toFixed(1) + 'px;height:' + (it.h * f).toFixed(1) + 'px;background-position:' + (-it.x * f).toFixed(1) + 'px ' + (-it.y * f).toFixed(1) + 'px;background-size:' + (SPR.W * f).toFixed(1) + 'px ' + (SPR.H * f).toFixed(1) + 'px"></i>'; }
  var LINES = {
    tap:   function () { return { c: img('tap', 118) + arrow('up') }; },
    scroll:function () { return { b: 'bubA', c: txt('scroll<br>down') }; },   /* in Leandro's alphabet (LUGAZI Hand), easier to read than the drawn one */
    keep1: function () { return { c: img('keep1', 132) + arrow('down') }; },
    keep2: function () { return { c: img('keep2', 118) + arrow('down') }; },
    keep3: function () { return { c: img('keep3', 112) + arrow('down') }; },
    swipe: function () { return { c: arrow('left') + txt('swipe') }; },
    join:  function () { return { b: 'signup' }; },
    book:  function () { return { b: 'click' }; },
    hello: function () { return { b: 'bubB', c: spr('hello') }; },
    menu:  function () { return { c: arrow('up') + txt('the sun<br>is the menu') }; },
    play:  function () { return { c: txt('tap to play') + arrow(lineDir) }; },
    /* tap the cat: it answers in cat language */
    mjav:  function () { return { b: 'mjav' }; },
    prrr:  function () { return { b: 'bubB', c: spr('prrr') }; },
    mjaw:  function () { return { b: 'square', c: spr('mjaw') }; },
    miaow: function () { return { b: 'wide', c: spr('miaow') }; },
    prrr2: function () { return { b: 'bubA', c: spr('prrr2') }; }
  };
  var EMPTY = ['bubA', 'square', 'wide', 'bubB'];
  var lineDir = 'up';
  /* the new lines never sit on top of anything: if the bubble would touch one of these, it stays away */
  var GUARDED = { book: 1, menu: 1, play: 1, join: 1, hello: 1, mjav: 1, prrr: 1, mjaw: 1, miaow: 1, prrr2: 1, scroll: 1, keep1: 1, keep2: 1, keep3: 1, swipe: 1 };
  var KEEP_CLEAR = '.lx-newpage .lwl-form > *, .lgz-machine, .lwl-trigger, .lw-book-button, .lx-player .lx-art-box, .lc-nav a, .lc-nav button, .lc-menu-toggle';
  function inView(el, a, b) { if (!el) return null; var r = el.getBoundingClientRect(); return r.width && r.top < vh() * (b || .9) && r.bottom > vh() * (a || .1) ? r : null; }
  var bubKey = '', bubW = 0, bubOn = false;
  var cur = null;   /* { b: bubble, c: content?, cw, ch } of the line on screen */
  var bubImg = null;
  function say(key) {
    if (!bub) return;
    if (!key) { if (bubOn) { bubOn = false; bub.classList.remove('is-on'); } return; }
    if (key !== bubKey || bubIn.dataset.dir !== lineDir) {
      bubKey = key; bubIn.dataset.dir = lineDir;
      var L = LINES[key]();
      bubIn.innerHTML = L.c || '';
      cur = { b: L.b || '', c: !!L.c, cw: 0, ch: 0 }; bubW = -1;
    }
    if (!bubOn) { bubOn = true; bub.classList.add('is-on'); }
  }
  function placeBubble() {
    if (!bubOn || !cur) return;
    if (!bubImg) { bub.classList.add('lgz-v2'); bubImg = document.createElement('i'); bubImg.className = 'lgz-bub__img'; bub.insertBefore(bubImg, bub.firstChild);
      bubImg.style.backgroundImage = 'url(' + SRC.getAttribute('data-bubbles') + ')'; }
    var cat = document.querySelector('.lc-cat'), cr = cat && cat.getBoundingClientRect(), W = vw(), H = vh(), f = 1 / SPR.S;
    var cx = cr && cr.width ? cr.left + cr.width * .5 : 60, top = cr && cr.width ? cr.top : H - 120;
    if (cr && (cr.bottom < 0 || cr.top > H)) { cx = 60; top = H - 120; }
    var rightGap = view() === 'book' ? 40 : 8;
    if (bubW === -1) {   /* new line: pick the bubble and its size once */
      var cw = cur.c ? bubIn.offsetWidth : 0, ch = cur.c ? bubIn.offsetHeight : 0, best = null;
      (cur.b ? [cur.b] : EMPTY).forEach(function (k) {
        var it = SPR.items[k], w0 = it.w * f, h0 = it.h * f, sc = 1;
        if (cur.c && it.inner) { var iw = (it.inner[2] - it.inner[0]) * w0, ih = (it.inner[3] - it.inner[1]) * h0; sc = Math.max((cw + 16) / iw, (ch + 10) / ih, .55); }
        var area = w0 * h0 * sc * sc; if (w0 * sc > vw() - 24) area *= 50;   /* a bubble wider than the screen only as a last resort */
        if (!best || area < best.area) best = { k: k, sc: sc, area: area, w: w0 * sc, h: h0 * sc };
      });
      /* every bubble stays a sensible size: never wider than 210 px or taller than 150 px - the words shrink to fit instead */
      var cap = Math.min(1, Math.min(210, vw() - 24) / best.w, 150 / best.h);
      cur.k = best.k; cur.w = best.w * cap; cur.h = best.h * cap; cur.cw = cw * cap; cur.ch = ch * cap; cur.zoom = cap; bubW = 0; cur.flip = null;
      bubIn.style.transformOrigin = '0 0'; bubIn.style.transform = cap < 1 ? 'scale(' + cap.toFixed(3) + ')' : '';
    }
    var it = SPR.items[cur.k], Wb = cur.w, Hb = cur.h;
    /* the tail tip sits right above the cat; an empty bubble may turn around when that keeps it on the screen */
    var tipL = it.tip[0] * Wb, x0 = cx - tipL, x1 = cx - (1 - it.tip[0]) * Wb;
    var lo = 8, hi = W - Wb - rightGap, off0 = Math.abs(clamp(x0, lo, hi) - x0), off1 = Math.abs(clamp(x1, lo, hi) - x1);
    var flip = !!(it.inner && cur.c && off1 + 2 < off0);
    if (cur.flip !== flip || bubW !== Wb) {
      cur.flip = flip; bubW = Wb;
      bub.style.width = Wb + 'px'; bub.style.height = Hb + 'px';
      bubImg.style.backgroundSize = (SPR.W * f * Wb / (it.w * f)).toFixed(1) + 'px ' + (SPR.H * f * Hb / (it.h * f)).toFixed(1) + 'px';
      bubImg.style.backgroundPosition = (-it.x * Wb / it.w).toFixed(1) + 'px ' + (-it.y * Hb / it.h).toFixed(1) + 'px';
      bubImg.style.transform = flip ? 'scaleX(-1)' : '';
      if (cur.c && it.inner) {
        var a = flip ? 1 - it.inner[2] : it.inner[0], b2 = flip ? 1 - it.inner[0] : it.inner[2];
        bubIn.style.left = (a * Wb + ((b2 - a) * Wb - cur.cw) / 2).toFixed(1) + 'px';
        bubIn.style.top = (it.inner[1] * Hb + ((it.inner[3] - it.inner[1]) * Hb - cur.ch) / 2).toFixed(1) + 'px';
      }
    }
    var x = clamp(flip ? x1 : x0, lo, hi), y = Math.max(safeTop + 8, top - it.tip[1] * Hb - 2);
    bub.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
    var blocked = false;
    if (GUARDED[bubKey]) {
      var bx = { left: x + 4, top: y + 4, right: x + Wb - 4, bottom: y + Hb - 6 };
      [].some.call(document.querySelectorAll(KEEP_CLEAR), function (el) {
        var r = el.getBoundingClientRect(); if (!r.width || !r.height || getComputedStyle(el).opacity === '0') return false;
        return (blocked = !(r.right <= bx.left || r.left >= bx.right || r.bottom <= bx.top || r.top >= bx.bottom));
      });
    }
    bub.classList.toggle('is-blocked', blocked);
  }
  function railHere() {
    var rails = document.querySelectorAll('.lwa-rail'), H = vh();
    for (var i = 0; i < rails.length; i++) { var r = rails[i].getBoundingClientRect(); if (r.top <= 4 && r.bottom > H * 1.02) return rails[i]; }
    return null;
  }
  function stageHere() {
    var s = document.querySelectorAll('.lgz-stage, .lx-ring-chapter, .lx-love-scene, .lx-figs, .lx-spin-chapter'), H = vh();
    for (var i = 0; i < s.length; i++) { var r = s[i].getBoundingClientRect(); if (r.height > H * 1.3 && r.top <= 4 && r.bottom > H * 1.08) return i; }
    return -1;
  }
  /* how far the big logo has landed: the page keeps it in window.__lxEnd (it no longer writes --lwa-end on <body>) */
  function logoLanding() { var e = typeof window.__lxEnd === 'number' ? window.__lxEnd : parseFloat(getComputedStyle(body).getPropertyValue('--lwa-end')) || 0; return e > .35; }
  function waitlistNear() { var p = document.querySelector('.lx-newpage'); return p && p.getBoundingClientRect().top < vh() * .9; }
  function homeEndNear() { var w = document.querySelector('.lw-world'); return w && w.getBoundingClientRect().bottom < vh() * 1.25; }
  function catFace(left) { var cat = document.querySelector('.lc-cat'); if (cat && left && cat.classList.contains('is-right')) cat.classList.remove('is-right'); }
  (function loop() { placeBubble(); requestAnimationFrame(loop); })();
  /* entrance: everyone taps the cat, so the cat opens the world too */
  document.addEventListener('click', function (e) {
    if (view() !== 'entrance' || !e.target.closest('.lc-cat')) return;
    var ent = document.querySelector('.lw-entrance'); if (ent) { e.preventDefault(); e.stopImmediatePropagation(); ent.click(); }
  }, true);
  /* the list gives you a number: "#014" next to the field, "#014 - you're in" after signing up */
  function listNumber() {
    var box = document.querySelector('.lwl'); if (!box || box.dataset.lgzNum) return;
    var form = box.querySelector('form'); if (!form) return;
    box.dataset.lgzNum = '1';
    var n = parseInt(SRC.getAttribute('data-next'), 10) || 1, tag = '#' + String(n).padStart(3, '0');
    var el = document.createElement('div');
    var done = form.querySelector('.lwl-done[data-posted]');
    if (done) { el.className = 'lgz-num lgz-num--done'; el.innerHTML = '<b>' + tag + '</b> &nbsp;you\'re in'; done.insertBefore(el, done.firstChild); return; }
    var field = form.querySelector('.lwl-hfield'); if (!field) return;
    el.className = 'lgz-num'; el.innerHTML = 'your number: <b>' + tag + '</b>'; field.after(el);
  }
  setInterval(listNumber, 800);

  var menuShown = 0, played = false, homeSince = 0, catSay = '', catUntil = 0, catN = 0;
  var CAT_WORDS = ['mjav', 'prrr', 'mjaw', 'miaow', 'prrr2'];
  /* the page's own cat code eats the click, so listen first, on the window, as the finger goes down */
  window.addEventListener('pointerdown', function (e) {
    if (view() === 'entrance' || !e.target.closest || !e.target.closest('.lc-cat')) return;
    catSay = CAT_WORDS[catN++ % CAT_WORDS.length]; catUntil = Date.now() + 1900;
  }, true);
  document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('.lx-player')) played = true; }, true);
  var DEBUG = /lgzdebug=1/.test(location.search);   /* ?lgzdebug=1: window.__lgzForce = 'menu' shows one line (for checking the shapes) */
  setInterval(function () {
    if (DEBUG && window.__lgzForce) { say(window.__lgzForce); return; }
    var v = view(), idle = Date.now() - last;
    if (body.classList.contains('lugazi-menu-open')) { say(''); return; }
    if (catUntil > Date.now() && v !== 'entrance') { lineDir = 'up'; say(catSay); return; }
    var box = document.querySelector('.lwa-box'); if (box && !box.hidden) { say(''); return; }
    if (v === 'entrance') { homeSince = 0; say(''); return; }
    if (v === 'home') {
      if (!homeSince) homeSince = Date.now();
      if (Date.now() - homeSince < 2400 && scroller().scrollTop < innerHeight * .3) { say('hello'); return; }
      if (inView(document.querySelector('.lw-book-button'), .05, .95)) { say('book'); return; }
      if (!menuShown && idle > 8000) { menuShown = Date.now(); }
      if (menuShown && Date.now() - menuShown < 4500) { say('menu'); return; }
      if (homeEndNear()) { say(''); return; }
      say(scroller().scrollTop < innerHeight * .35 || idle > 2500 ? 'scroll' : '');
      return;
    }
    if (v === 'book') {
      var wl = document.querySelector('.lx-newpage'), wlTop = wl ? wl.getBoundingClientRect().top : 1e9;
      if (wlTop < vh() * .95) { say(''); return; }         /* the list page is on screen: the bubble never covers it */
      if (logoLanding()) { say('join'); return; }
      var rail = railHere();
      if (rail) {
        var rr = rail.getBoundingClientRect(), prog = -rr.top / Math.max(1, rr.height - vh());
        say('scroll');   /* the sideways chapter moves when you scroll down, so the cat says scroll, not swipe */
        return;
      }
      var pl = !played && inView(document.querySelector('.lx-player .lx-art-box'), .15, .85);
      if (pl) { var cy2 = (document.querySelector('.lc-cat') || { getBoundingClientRect: function () { return { top: vh() - 120 }; } }).getBoundingClientRect().top;
        lineDir = pl.top + pl.height / 2 < cy2 ? 'up' : 'down'; say('play'); return; }
      var st = stageHere();
      if (st >= 0) { say(['keep1', 'keep2', 'keep3'][st % 3]); return; }
      if (scroller().scrollTop < innerHeight * .35) { say('scroll'); return; }
      say(idle > 2200 && !nearEnd() ? ['keep1', 'keep2', 'keep3'][stops % 3] : '');
      if (idle > 2200 && idle < 2500) stops++;
      return;
    }
    say('');
  }, 200);

  /* Mask (BOOK 6367) - kept hand-made: every line re-draws itself a few times a second like a pen drawing
     (boil), the flames lick harder than the face, the eight pupils inside the flower eyes look at you (finger/mouse,
     otherwise they wander), blink now and then, widen when the mask comes into view and narrow when you get close.
     Runs only while the mask is on screen. The original image stays underneath for the zoom view. */
  var MASK = { id: '6367', W: 1133, H: 1388,
    pupils: [[441.2, 456.5, 6.6, 17.2], [503.9, 458.8, 7.4, 19.3], [446.5, 519.7, 6.6, 16.5], [501.7, 516.4, 6.6, 17.7],
             [657.1, 458.8, 6.6, 18.4], [716.7, 453.5, 6.4, 18.2], [652.0, 525.4, 6.6, 18.5], [713.6, 524.8, 7.0, 18.6]],
    eyes: [[472, 488], [688, 488]] };
  function svgEl(t, a) { var e = document.createElementNS('http://www.w3.org/2000/svg', t); for (var k in a) e.setAttribute(k, a[k]); return e; }
  function maskLife() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var pg = document.querySelector('.lw-collage-page[data-book-id="' + MASK.id + '"]');
    if (!pg || pg.__lgzMask) return;
    var paper = pg.querySelector('.lwa-paper') || pg, src = paper.querySelector('img');
    if (!src || !src.complete || !src.naturalWidth) return;
    pg.__lgzMask = true;
    var W = MASK.W, H = MASK.H, href = src.currentSrc || src.src;
    var svg = svgEl('svg', { 'class': 'lgz-mask', viewBox: '0 0 ' + W + ' ' + H, preserveAspectRatio: 'xMidYMid meet', 'aria-hidden': 'true' });
    var defs = svgEl('defs', {});
    /* weight map: 0 in the face, 1 out in the flames (data-URI image, works in Safari) */
    var grad = '<svg xmlns="http://www.w3.org/2000/svg" width="' + W + '" height="' + H + '" viewBox="0 0 1 1" preserveAspectRatio="none">' +
      '<radialGradient id="g" cx=".49" cy=".47" r=".5"><stop offset=".6" stop-color="#000"/><stop offset=".84" stop-color="#fff"/></radialGradient>' +
      '<rect width="1" height="1" fill="url(#g)"/></svg>';
    var f = svgEl('filter', { id: 'lgz-boil-m', x: '-4%', y: '-4%', width: '108%', height: '108%', 'color-interpolation-filters': 'sRGB' });
    var turb = svgEl('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.022', numOctaves: coarse ? '1' : '2', seed: '1', result: 'n0' });
    f.appendChild(turb);
    f.appendChild(svgEl('feColorMatrix', { 'in': 'n0', type: 'matrix', values: '1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0 1', result: 'n' }));
    f.appendChild(svgEl('feImage', { href: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(grad), x: 0, y: 0, width: W, height: H, preserveAspectRatio: 'none', result: 'w' }));
    /* map = 0.5 + (n - 0.5) * (0.3 + 0.7 * w): calm face, wild flames */
    f.appendChild(svgEl('feComposite', { 'in': 'n', in2: 'w', operator: 'arithmetic', k1: '0.7', k2: '0.3', k3: '-0.35', k4: '0.35', result: 'map' }));
    var disp = svgEl('feDisplacementMap', { 'in': 'SourceGraphic', in2: 'map', scale: '15', xChannelSelector: 'R', yChannelSelector: 'G' });
    f.appendChild(disp); defs.appendChild(f); svg.appendChild(defs);
    var g = svgEl('g', { filter: 'url(#lgz-boil-m)' });
    var im = svgEl('image', { width: W, height: H, preserveAspectRatio: 'xMidYMid meet' });
    im.setAttribute('href', href); im.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', href);
    g.appendChild(im); svg.appendChild(g);
    /* eyes live in their own layer so moving pupils never re-runs the boil filter */
    var eyesSvg = svgEl('svg', { 'class': 'lgz-mask', viewBox: '0 0 ' + W + ' ' + H, preserveAspectRatio: 'xMidYMid meet', 'aria-hidden': 'true' });
    var eyesDefs = svgEl('defs', {}); eyesSvg.appendChild(eyesDefs);
    var eyesG = svgEl('g', {}), dots = [];
    MASK.pupils.forEach(function (p) {
      eyesG.appendChild(svgEl('circle', { cx: p[0], cy: p[1], r: p[2] + 4.5, fill: '#fbfbfa' }));
      var clip = svgEl('clipPath', { id: 'lgz-pc' + dots.length }); clip.appendChild(svgEl('circle', { cx: p[0], cy: p[1], r: p[3] + 1 })); eyesDefs.appendChild(clip);
      var cg = svgEl('g', { 'clip-path': 'url(#lgz-pc' + dots.length + ')' });
      var d = svgEl('ellipse', { cx: p[0], cy: p[1], rx: p[2], ry: p[2], fill: '#0d0d0d' });
      cg.appendChild(d); eyesG.appendChild(cg);
      dots.push({ el: d, x: p[0], y: p[1], r: p[2], room: Math.max(3, p[3] - p[2] - 3.2) });
    });
    eyesSvg.appendChild(eyesG);
    paper.appendChild(svg); paper.appendChild(eyesSvg); pg.classList.add('lgz-mask-on');

    /* state */
    var on = false, raf = 0, boilT = 0, seeds = [1, 7, 13, 21, 34, 55], si = 0, burst = 0;
    var look = { x: 0, y: 0 }, aim = { x: 0, y: 0 }, pointerAt = 0, px = 0, py = 0;
    var lastKey = '', pupil = 1, pupilAim = 1, lid = 1, blinkAt = performance.now() + 2500, blinkT = -1, nextWander = 0, lastSeen = 0;
    function shake() { [svg, eyesSvg].forEach(function (e) { e.classList.remove('is-shake'); e.getBoundingClientRect(); e.classList.add('is-shake'); }); }
    function wake() { pupil = 1.55; pupilAim = 1; burst = performance.now() + 650; shake(); }
    addEventListener('pointermove', function (e) { px = e.clientX; py = e.clientY; pointerAt = performance.now(); }, { passive: true });
    addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) { px = t.clientX; py = t.clientY; pointerAt = performance.now(); } }, { passive: true });
    pg.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { pupilAim = .62; burst = performance.now() + 420; shake(); } });
    pg.addEventListener('pointerleave', function () { pupilAim = 1; });

    function frame(t) {
      raf = on ? requestAnimationFrame(frame) : 0;
      /* boil: new hand-drawn frame ~9 times a second, wilder for a moment on wake */
      if (t - boilT > (coarse ? 170 : 110)) {
        boilT = t; si = (si + 1 + (Math.random() * 2 | 0)) % seeds.length;
        turb.setAttribute('seed', seeds[si]);
        disp.setAttribute('scale', t < burst ? 30 : 15);
      }
      /* where to look */
      var r = svg.getBoundingClientRect(), k = r.width / W;
      if (t - pointerAt < 2600 && r.width) {
        var cx = r.left + (MASK.eyes[0][0] + MASK.eyes[1][0]) / 2 * k, cy = r.top + MASK.eyes[0][1] * k;
        var dx = px - cx, dy = py - cy, dist = Math.hypot(dx, dy) || 1, m = Math.min(1, dist / (r.width * .55));
        aim.x = dx / dist * m; aim.y = dy / dist * m;
      } else if (t > nextWander) {
        var a = Math.random() * Math.PI * 2, mm = Math.random() < .3 ? 0 : .45 + Math.random() * .55;
        aim.x = Math.cos(a) * mm; aim.y = Math.sin(a) * mm * .8; nextWander = t + 900 + Math.random() * 2600;
      }
      look.x += (aim.x - look.x) * .16; look.y += (aim.y - look.y) * .16;   /* quick saccade, soft landing */
      pupil += (pupilAim - pupil) * .06;
      /* blink: close 70 ms, hold 50 ms, open 110 ms; sometimes a double blink */
      if (blinkT < 0 && t > blinkAt) blinkT = t;
      if (blinkT >= 0) {
        var bt = t - blinkT;
        lid = bt < 70 ? 1 - bt / 70 * .92 : bt < 120 ? .08 : bt < 230 ? .08 + (bt - 120) / 110 * .92 : 1;
        if (bt >= 230) { blinkT = -1; blinkAt = t + (Math.random() < .2 ? 160 : 2600 + Math.random() * 4200); }
      }
      var key = look.x.toFixed(3) + look.y.toFixed(3) + pupil.toFixed(3) + lid.toFixed(2);
      if (key === lastKey) return; lastKey = key;
      dots.forEach(function (d) {
        d.el.setAttribute('cx', (d.x + look.x * d.room).toFixed(2));
        d.el.setAttribute('cy', (d.y + look.y * d.room).toFixed(2));
        d.el.setAttribute('rx', (d.r * pupil).toFixed(2));
        d.el.setAttribute('ry', (d.r * pupil * lid).toFixed(2));
      });
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var was = on; on = e.isIntersecting && e.intersectionRatio > .2;
        if (on && !was) { var now = performance.now(); if (now - lastSeen > 3500) setTimeout(wake, 380); if (!raf) raf = requestAnimationFrame(frame); }
        if (!on && was) lastSeen = performance.now();
      });
    }, { threshold: [0, .2, .5] }).observe(pg);
  }

  /* BOOK 8135 (mannequins + people): the picture holds on screen for a while (resistance). While you keep scrolling the
     red creatures sneak in one by one - peeking from behind the mannequins, the girl and the hood, creeping in from the
     sides, one drops down and hangs from the girl's hand, a red XXX tag gets sprayed onto the canvas - then the one with
     XXX on its belly walks up close and reaches out its hand. Scroll on and they flee: back behind the mannequin, into the
     bag, behind the hood, the hanging one lets go, the rest run off. Scroll back up and they come back. */
  /* the creatures drawing (Files: lugazi-peekers_1.webp, 2371 x 752); boxes in its pixels */
  var CR = { src: 'https://cdn.shopify.com/s/files/1/1095/9093/7938/files/lugazi-peekers_1.webp?v=1791528448&width=1600',
    sheetW: 2371, sheetH: 752,
    c1: [3, 3, 439, 746], c2: [453, 2, 500, 729], c3: [965, 3, 211, 314], c4: [1188, 3, 372, 542], c5: [1572, 3, 227, 397],
    h1: [1809, 2, 312, 227], h2: [2132, 3, 230, 214], arm: [1194, 198, 116, 174], armPivot: [100, 24],
    armPoly: [[96, 0], [116, 8], [115, 42], [107, 64], [102, 92], [86, 126], [78, 158], [52, 174], [16, 174], [0, 132], [24, 106], [48, 60], [76, 16]] };
  /* u,v = where the creature's feet (bottom centre) end up, in photo fractions; from = where it starts hiding;
     win = scroll window it moves in; layer back = behind the photo; clip = it rises from behind a line in the photo
     (the canvas peak, the bag); size = height as part of the photo height */
  var CAST = [
    { k: 'h2', layer: 'back',  size: .11, u: .10, v: .165, from: [.10, .30], win: [.04, .18], hide: true },  /* over a mannequin head */
    { k: 'c3', layer: 'front', size: .17, u: .776, v: .382, from: [.776, -.32], win: [.11, .25], hang: true }, /* drops down and hangs from her hand */
    { k: 'c5', layer: 'front', size: .16, u: .585, v: .44, from: [.585, .60], win: [.19, .34], clip: .372, hide: true }, /* crawls out of the bag */
    { k: 'h1', layer: 'back',  size: .10, u: .87, v: .465, from: [.87, .64], win: [.27, .41], hide: true },  /* over the hood */
    { k: 'c2', layer: 'front', size: .46, u: .05, v: 1.0, from: [-.55, 1.0], win: [.34, .52] },
    { k: 'c1', layer: 'front', size: .44, u: .26, v: 1.04, from: [.26, 1.65], win: [.42, .60] },
    { k: 'c4', layer: 'front', size: .33, u: .70, v: 1.0, from: [1.6, 1.0], win: [.50, .68], greeter: true }
  ];
  function stageLife() {
    var pg = document.querySelector('.lw-collage-page[data-book-id="8135"]');
    if (!pg || pg.__lgzStage) return;
    var sec = pg.closest('.lw-collage-spread'); if (!sec) return;
    pg.__lgzStage = true;
    var sheet = CR.src, reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sticky = document.createElement('div'); sticky.className = 'lgz-sticky';
    var back = document.createElement('div'); back.className = 'lgz-crl lgz-crl--back';
    var front = document.createElement('div'); front.className = 'lgz-crl lgz-crl--front';
    sec.insertBefore(sticky, pg); sticky.appendChild(back); sticky.appendChild(pg); sticky.appendChild(front);
    sec.classList.add('lgz-stage');
    /* (12 Oct) a phone's address bar slides in and out while you scroll and changes innerHeight by up to ~120 px:
       the stage keeps its height then (or everything below it would jump); it only resizes when the width changes
       (turning the phone, a new window size) or the height changes a lot */
    var stageW = 0, stageH = 0;
    function sizeStage() {
      var H = innerHeight, W = innerWidth;
      if (stageH && W === stageW && Math.abs(H - stageH) < 160) return;
      stageW = W; stageH = H; sec.style.setProperty('--lgz-vh', H + 'px');
      sticky.style.height = H + 'px'; sec.style.height = Math.round(H * 2.1) + 'px';
    }
    sizeStage(); addEventListener('resize', sizeStage);
    var actors = CAST.map(function (c, i) {
      var r = CR[c.k], el = document.createElement('div'); el.className = 'lgz-cr'; el.setAttribute('aria-hidden', 'true');
      el.style.backgroundImage = 'url("' + sheet + '")';
      var a = { c: c, r: r, el: el, bg: el, x: 0, y: 0, s: 1, rot: 0, op: 0, seed: i * 1.7 + .3, arm: null };
      if (c.greeter) {
        var A = CR.arm, dx = A[0] - r[0], dy = A[1] - r[1];
        var pts = CR.armPoly.map(function (q) { return (q[0] + dx) + ',' + (q[1] + dy); }).join(' ');
        var hole = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + r[2] + ' ' + r[3] + '" preserveAspectRatio="none"><path fill-rule="evenodd" d="M0 0H' + r[2] + 'V' + r[3] + 'H0Z M' + pts.replace(/ /g, ' L') + 'Z"/></svg>';
        var mu = 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent(hole) + '")';
        var body = document.createElement('i'); body.className = 'lgz-arm'; body.style.cssText = 'inset:0;background-image:url("' + sheet + '")';
        body.style.webkitMaskImage = mu; body.style.maskImage = mu; body.style.webkitMaskSize = '100% 100%'; body.style.maskSize = '100% 100%';
        el.style.backgroundImage = 'none'; el.appendChild(body); a.bg = body;
        var arm = document.createElement('i'); arm.className = 'lgz-arm'; arm.style.backgroundImage = 'url("' + sheet + '")';
        arm.style.clipPath = 'polygon(' + CR.armPoly.map(function (q) { return (q[0] / A[2] * 100).toFixed(1) + '% ' + (q[1] / A[3] * 100).toFixed(1) + '%'; }).join(',') + ')';
        el.appendChild(arm); a.arm = arm; a.armRot = 0;
      }
      var host = c.layer === 'back' ? back : front;
      if (c.clip != null) { var cw = document.createElement('div'); cw.className = 'lgz-crl'; host.appendChild(cw); host = cw; a.clipEl = cw; }
      host.appendChild(el);
      return a;
    });
    /* the tag: a red spray-paint scribble (star, XXX, swoosh, drips) that gets sprayed onto the canvas while you scroll */
    var TAG = ['M30 72 L45 28 L58 74 L16 44 L74 47 Z', 'M84 38 L104 76', 'M104 38 L84 76', 'M114 38 L134 76', 'M134 38 L114 76',
               'M144 38 L164 76', 'M164 38 L144 76', 'M12 98 C 60 114, 128 82, 194 94', 'M94 78 L95 97', 'M152 79 L152 92', 'M40 74 L41 88'];
    var tagSvg = svgEl('svg', { 'class': 'lgz-tag', viewBox: '0 0 206 120', 'aria-hidden': 'true' }), tdefs = svgEl('defs', {});
    var tf = svgEl('filter', { id: 'lgz-spray', x: '-10%', y: '-10%', width: '120%', height: '120%' });
    tf.appendChild(svgEl('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.9', numOctaves: '1', seed: '4', result: 'n' }));
    tf.appendChild(svgEl('feDisplacementMap', { 'in': 'SourceGraphic', in2: 'n', scale: '2.6', xChannelSelector: 'R', yChannelSelector: 'G' }));
    var tg = svgEl('filter', { id: 'lgz-spray-soft', x: '-20%', y: '-20%', width: '140%', height: '140%' });
    tg.appendChild(svgEl('feGaussianBlur', { stdDeviation: '2.2' }));
    tdefs.appendChild(tf); tdefs.appendChild(tg); tagSvg.appendChild(tdefs);
    var haze = svgEl('g', coarse ? { opacity: '.2' } : { filter: 'url(#lgz-spray-soft)', opacity: '.28' }), ink = svgEl('g', coarse ? {} : { filter: 'url(#lgz-spray)' });
    tagSvg.appendChild(haze); tagSvg.appendChild(ink);
    var strokes = TAG.map(function (d, n) {
      var drip = n >= 8, a1 = svgEl('path', { d: d, fill: 'none', stroke: '#c8101c', 'stroke-width': drip ? 2.4 : 6.5, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' });
      var a2 = svgEl('path', { d: d, fill: 'none', stroke: '#e0202c', 'stroke-width': drip ? 5 : 15, 'stroke-linecap': 'round' });
      ink.appendChild(a1); haze.appendChild(a2);
      return { a: a1, b: a2, len: 0, drip: drip };
    });
    front.insertBefore(tagSvg, front.firstChild);
    var tagLen = 0, tagP = -1, tagW = 0;
    var on = false, raf = 0, fled = false, fleeAt = 0, stepT = 0, step = 0, lastScroll = 0, prevP = 0;
    function drawTag(p, ox, oy, PW, PH) {
      if (!tagLen) { strokes.forEach(function (s) { s.len = s.a.getTotalLength() || 1; if (!s.drip) tagLen += s.len; }); }
      var W = PW * .21;
      var css = 'position:absolute;left:' + (ox + PW * .125).toFixed(1) + 'px;top:' + (oy + PH * .43).toFixed(1) + 'px;width:' + W.toFixed(1) + 'px;height:' + (W * 120 / 206).toFixed(1) + 'px;transform:rotate(-24deg);overflow:visible;pointer-events:none;mix-blend-mode:multiply';
      if (tagSvg.__lgzCss !== css) { tagSvg.__lgzCss = css; tagSvg.style.cssText = css; }
      var done = Math.max(0, Math.min(1, (p - .46) / .2)) * tagLen, dripT = Math.max(0, Math.min(1, (p - .66) / .08));
      strokes.forEach(function (s) {
        var shown;
        if (s.drip) shown = s.len * dripT;
        else { shown = Math.max(0, Math.min(s.len, done)); done -= s.len; }
        var dash = s.len + ' ' + s.len, off = (s.len - shown).toFixed(2);
        s.a.style.strokeDasharray = dash; s.a.style.strokeDashoffset = off;
        s.b.style.strokeDasharray = dash; s.b.style.strokeDashoffset = off;
      });
    }
    function ease(t) { return t < 0 ? 0 : t > 1 ? 1 : t * t * (3 - 2 * t); }
    /* (12 Oct) only write a style when it really changes: the same sizes written again every frame made the phone lay
       out the whole book over and over while you scroll */
    function put(el, prop, v) { var m = el.__lgzSet || (el.__lgzSet = {}); if (m[prop] !== v) { m[prop] = v; el.style[prop] = v; } }
    function frame(t) {
      raf = on ? requestAnimationFrame(frame) : 0;
      var H = stageH || innerHeight, rs = sec.getBoundingClientRect(), fs = rs.height / (sec.offsetHeight || rs.height) || 1, travel = sec.offsetHeight - H;
      var p = travel > 0 ? Math.max(0, Math.min(1, -rs.top / fs / travel)) : 0;
      if (Math.abs(p - prevP) > .0005) lastScroll = t; prevP = p;
      if (t - stepT > 120) { stepT = t; step++; }          /* hand-animated: poses change on "twos" */
      if (!fled && p > .9) { fled = true; fleeAt = t; }
      if (fled && p < .8) fled = false;
      var sr = sticky.getBoundingClientRect(), pr = pg.getBoundingClientRect();
      /* the spread may be scaled by the book's own reveal animation: work in the layer's own (unscaled) pixels */
      var f = sr.width / (sticky.offsetWidth || sr.width) || 1;
      var ox = (pr.left - sr.left) / f, oy = (pr.top - sr.top) / f, PW = pr.width / f, PH = pr.height / f, cx = ox + PW / 2, cy = oy + PH * .55;
      var moving = t - lastScroll < 160;
      if (Math.abs(p - tagP) > .0005 || PW !== tagW) { tagP = p; tagW = PW; drawTag(p, ox, oy, PW, PH); }
      actors.forEach(function (a, i) {
        var c = a.c, r = a.r, k = (c.size * PH) / r[3], w = r[2] * k, h = r[3] * k;
        var q = ease((p - c.win[0]) / (c.win[1] - c.win[0]));
        var u = c.from[0] + (c.u - c.from[0]) * q, v = c.from[1] + (c.v - c.from[1]) * q;
        var tx = ox + u * PW - w / 2, ty = c.hang ? oy + v * PH - h * .03 : oy + v * PH - h, sc = 1, rot = 0, op = q > 0 ? 1 : 0, armRot = 0;
        if (c.hang) {
          /* caught her hand: a big swing that settles into a lazy one */
          if (q >= 1 && !a.caught) a.caught = t; if (q < 1) a.caught = 0;
          var amp = a.caught ? 7 + 16 * Math.exp(-(t - a.caught) / 900) : 0;
          rot = q >= 1 ? Math.sin((t - (a.caught || t)) / 420) * amp : (moving ? (step % 2 ? 4 : -4) : 0);
        }
        /* tiptoe while walking in: little hops and wobble, changed in steps like a drawn animation */
        else if (q > 0 && q < 1 && moving) { var ph = step + i; ty -= (ph % 2) * h * .035; rot = (ph % 2 ? 3.5 : -3.5); }
        else if (q >= 1) { rot = Math.sin(t / 900 + a.seed) * 1.6; }          /* standing: slight sway */
        if (c.greeter) {
          var gq = ease((p - .66) / .16);
          if (gq > 0) {
            sc = 1 + gq * .95;                                       /* comes closer */
            tx += ((cx - w / 2) - tx) * gq * .55;                    /* towards the middle */
            ty += h * gq * .22;                                      /* and lower, as if stepping out of the picture */
            armRot = gq * 58 + (gq >= 1 ? Math.sin(t / 260) * 7 : 0); /* reaches out, then a little wave */
            if (moving && gq < 1) { var ph2 = step; ty -= (ph2 % 2) * h * .03; rot = ph2 % 2 ? 2.5 : -2.5; }
          }
        }
        if (fled && c.hide) {
          /* ducks back into its hiding place: behind the mannequin, into the bag, behind the hood */
          tx = ox + c.from[0] * PW - w / 2; ty = oy + c.from[1] * PH - h; rot = 0;
        } else if (fled && c.hang) {
          /* lets go of her hand and drops out of the picture */
          var dt = Math.max(0, (t - fleeAt) / 700); ty += dt * dt * innerHeight * 1.4; rot = dt * 40;
        } else if (fled) {
          /* run away from the middle of the picture, each its own way */
          var ft = Math.min(1, (t - fleeAt - i * 45) / 650); if (ft < 0) ft = 0;
          var fx = (ox + u * PW) - cx, fy = (oy + v * PH - h / 2) - cy, fd = Math.hypot(fx, fy) || 1;
          if (Math.abs(fx) < 8) fx = i % 2 ? 40 : -40;
          var far = Math.max(innerWidth, H) * 1.3 * ft * ft;
          tx += fx / fd * far; ty += fy / fd * far * .6 - Math.abs(Math.sin(ft * 9)) * h * .12;
          rot = (fx > 0 ? 1 : -1) * (8 + (step % 2) * 6); armRot = c.greeter ? 20 : 0;
        }
        /* smooth towards target (sneaky ease), quick when fleeing */
        var L = fled ? .5 : reduced ? 1 : .22;
        if (!a.init) { a.init = true; a.x = tx; a.y = ty; }
        a.x += (tx - a.x) * L; a.y += (ty - a.y) * L; a.s += (sc - a.s) * L; a.rot += (rot - a.rot) * .5; a.op = op;
        var el = a.el, sheetK = k;
        put(el, 'width', w.toFixed(1) + 'px'); put(el, 'height', h.toFixed(1) + 'px');
        var bgs = (CR.sheetW * sheetK).toFixed(1) + 'px ' + (CR.sheetH * sheetK).toFixed(1) + 'px';
        put(a.bg, 'backgroundSize', bgs);
        put(a.bg, 'backgroundPosition', (-r[0] * sheetK).toFixed(1) + 'px ' + (-r[1] * sheetK).toFixed(1) + 'px');
        put(el, 'opacity', String(a.op));
        if (a.clipEl) put(a.clipEl, 'clipPath', fled && !c.hide ? 'none' : 'inset(-100vh -100vw ' + Math.max(0, sr.height / f - (oy + c.clip * PH)).toFixed(1) + 'px -100vw)');
        if (c.hang) put(el, 'transformOrigin', '50% 3%');
        put(el, 'transform', 'translate(' + a.x.toFixed(1) + 'px,' + a.y.toFixed(1) + 'px) rotate(' + a.rot.toFixed(2) + 'deg) scale(' + a.s.toFixed(3) + ')');
        if (a.arm) {
          var A = CR.arm;
          put(a.arm, 'width', (A[2] * sheetK).toFixed(1) + 'px'); put(a.arm, 'height', (A[3] * sheetK).toFixed(1) + 'px');
          put(a.arm, 'left', ((A[0] - r[0]) * sheetK).toFixed(1) + 'px'); put(a.arm, 'top', ((A[1] - r[1]) * sheetK).toFixed(1) + 'px');
          put(a.arm, 'backgroundSize', bgs);
          put(a.arm, 'backgroundPosition', (-A[0] * sheetK).toFixed(1) + 'px ' + (-A[1] * sheetK).toFixed(1) + 'px');
          put(a.arm, 'transformOrigin', (CR.armPivot[0] * sheetK).toFixed(1) + 'px ' + (CR.armPivot[1] * sheetK).toFixed(1) + 'px');
          a.armRot += (armRot - a.armRot) * .25;
          put(a.arm, 'transform', 'rotate(' + a.armRot.toFixed(1) + 'deg)');
        }
      });
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { on = e.isIntersecting; if (on && !raf) raf = requestAnimationFrame(frame); });
    }, { rootMargin: '200px 0px' }).observe(sec);
  }
  /* END OF BOOK: no "u made it this far" stop. After the last page the logo lands, and the e-mail field is right there. */
  function endLayout() {
    var stage = document.querySelector('.lx-stage'), page = document.querySelector('.lx-newpage');
    if (!page || page.dataset.lgzEnd) return;
    page.dataset.lgzEnd = '1';
    if (stage) { var gap = document.createElement('div'); gap.className = 'lgz-endgap'; stage.replaceWith(gap); }
    var logo = document.createElement('img'); logo.className = 'lgz-endlogo'; logo.src = SRC.getAttribute('data-wordmark'); logo.alt = 'LUGAZI'; logo.width = 1200; logo.height = 400;
    page.insertBefore(logo, page.firstChild);
  }
  function bookSizes() {
    endLayout();
    var w = document.querySelector('.lw-collage-page[data-book-id="3736"]'), hd = document.querySelector('.lw-collage-page[data-book-id="8316"]');
    if (w && w.parentElement) w.closest('.lw-collage-spread').classList.add('lgz-small-hero');
    if (hd) hd.closest('.lw-collage-spread').classList.add('lgz-hoodie-first');
  }
  setInterval(function () { if (view() === 'book') { bookSizes(); maskLife(); stageLife(); } }, 1000);
  /* the sideways chapter measures where it starts and how long it is once, when the book is built. Things above it
     grow afterwards (the mannequin scene, images, the phone's address bar), so whenever the book changes height we ask
     it to measure again - otherwise the last sideways pages never slide in before the page scrolls on */
  (function () {
    var lastH = 0, t = 0;
    function remeasure() { clearTimeout(t); t = setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 120); }
    setInterval(function () {
      if (view() !== 'book') return;
      /* (12 Oct) only for the old scroll-driven sideways chapter (it is a swipe row now), and never while a picture is
         open big: the fake resize sent the whole page measuring in the middle of every scroll (glitchy on phones) and,
         with a picture open, left BOOK unable to scroll after closing it */
      if (!document.querySelector('.lwa-rail .lwa-track')) return;
      var box = document.querySelector('.lwa-box'); if (box && !box.hidden) return;
      var s = scroller(), h = s ? s.scrollHeight : 0;
      if (h && Math.abs(h - lastH) > 2) { lastH = h; remeasure(); }
    }, 500);
    addEventListener('load', remeasure);
    /* the sideways chapter must be exactly as long as its pages are wide: if the pictures made the row wider (or
       narrower) after it was measured, the last pages would never slide in - check, and measure again if needed */
    setInterval(function () {
      if (view() !== 'book') return;
      var rail = document.querySelector('.lwa-rail'), track = rail && rail.querySelector('.lwa-track');
      if (!rail || !track) return;
      var need = Math.max(0, track.scrollWidth - innerWidth) * 0.32 + innerHeight, have = rail.offsetHeight;
      if (Math.abs(need - have) > 24) remeasure();
    }, 600);
  })();

})();
